import { useCallback } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { downloadDeliveryWorkAttachment } from 'repositories/ShipmentApi/downloadDeliveryWorkAttachment'
import { useAttachmentBlobPreview } from 'components/AttachmentPreview/useAttachmentBlobPreview'

type RouteParams = {
  deliveryReportUid: string
  shipmentUid: string
  visitId: string
  attachmentId: string
}

export const useAttachmentPreviewController = () => {
  const { deliveryReportUid, shipmentUid, visitId, attachmentId } = useParams<RouteParams>()
  const { search } = useLocation()
  const fileName = new URLSearchParams(search).get('name') ?? ''

  const fetchBlob = useCallback(
    () =>
      downloadDeliveryWorkAttachment({
        shipmentUid,
        visitId: Number(visitId),
        attachmentId: Number(attachmentId),
        deliveryReportUid,
      }),
    [shipmentUid, visitId, attachmentId, deliveryReportUid]
  )

  return useAttachmentBlobPreview(fileName, fetchBlob)
}
